<template>
  <Modal
    :title="title"
    :width="width"
    v-model="showDialog"
    :mask-closable="false"  sticky reset-drag-position :mask="false" draggable
    @on-visible-change="closeDialog"
  >
    <div>
      <label class="prefix"><span style="color: red">*</span>
        意图名称：
      </label>
      <el-input class="suffix" v-model="indentData.name" size="small" placeholder="限制50个字符" :maxlength="50"></el-input>
    </div>
    <div>
      <label class="prefix">
        <span style="color: red">*</span>
        用户话术
        <Poptip transfer placement="top" width="300" word-wrap content="请在这里输入用户可能的说法，并且确保该所含词槽已经创建完成" trigger="hover">
          <img :src="questionMark" class="tip-img"/>
        </Poptip>：
      </label>
      <template v-for="(ask,index) in indentData.asks">
        <div :key="index" :class="{suffix:true,offsetX:index!==0}">

          <el-input
            v-model="ask.expression"
            size="small"
            type="textarea" :rows="5"
            style="width: 100%"
            placeholder="请输入话术,限制255个字符"
            :maxlength="255">
            <!--<template slot="append">
              <el-popover placement="left" width="300" content="勾选严格匹配，代表当用户的问题与该说法完全一样的情况下，才会识别命中。" trigger="hover">
                <el-checkbox slot="reference" v-model="ask.type" :true-label="2" :false-label="1">严格匹配</el-checkbox>
              </el-popover>
            </template>-->
          </el-input>

          <!--<i class="el-icon-delete" style="cursor: pointer" @click.prevent="handleDeleteAsk(ask)"></i>-->
        </div>
      </template>
      <!--<div style="margin-top: 10px" :class="{addClass:true,addOffsetX:indentData.asks.length<=0}">
        <a @click="handleAddAsk" :class="{addOffsetX:indentData.asks.length>0}">+新增话术</a>
      </div>-->
    </div>
    <div>
      <label class="prefix">语义槽（推荐）
        <Poptip placement="top" transfer width="300" word-wrap content="通过设置语义槽，使机器人能够识别用户话术中的关键信息，更好地理解用户意图" trigger="hover">
          <img :src="questionMark" class="tip-img"/>
        </Poptip>：
      </label>
      <el-table
        :data="indentData.slots"
        border
        style="width: 75%;display: inline-grid;margin-top: 10px;">
        <el-table-column
          width="150"
          label="所收集参数名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.paramName" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="使用的识别能力">
          <template slot-scope="scope">
            <el-autocomplete
              v-model="scope.row.tempName"
              placeholder="识别能力"
              :fetch-suggestions="querySearch"
              size="small"
              :popper-append-to-body="false"
              @select="handleSelect(scope.row)"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column
          width="60"
          label="操作">
          <template slot-scope="scope">
            <el-button icon="el-icon-delete" @click="handleDelete(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px">
        <a @click="handleAdd" style="margin-left: 20%;">+新增语义槽</a>
      </div>
    </div>
    <!--页脚-->
    <div slot="footer">
      <el-button type="primary" @click.prevent="submitIndent" size="small">确定</el-button>
      <el-button @click="showDialog=false" size="small">取消</el-button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: "IndentDialog",
    props:['indentId','show','isEdit','flowId'],
    data(){
      return {
        title:'新增意图',
        width:800,
        showDialog:false,
        sysSlot:[],
        indentData:{id:'',name:'',asks:[{expression:''}],slots:[]},
        deleteSlots:[],
        deleteExpressions:[],
        questionMark:require('../../../assets/image/homeAsk.png'),
      }
    },
    methods:{
      initSlot(flowId) {
        let param = {rwId:flowId}
        let that = this
        this.$http.post('/AI/FlowDetail/queryAutoCompleteNouns',param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          let slots = response.obj
          if (slots) {
            this.sysSlot = []
            let that = this
            slots.forEach(slot => {
              let s = {}
              s.id = slot.id
              s.value = '@' + slot.rpnName
              s.type = slot.pType
              s.label = '@' + slot.rpnName
              that.sysSlot.push(s)
            })
          }
        })
      },
      closeDialog(val) {
        this.$emit('close',val)
      },
      loadData(id) {
        let param = {rwId: this.flowId, id: id}
        let that = this
        this.$http.post('/AI/FlowDetail/queryIndentById',param).then(res=>{
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          let _data = response.obj
          let indent = {}
          indent.id = _data.id
          indent.slots = _data.slots
          indent.name = _data.name
          if (indent.slots) {
            indent.slots.forEach(s=>{
              s.tempName = '@' + s.nounName
              s.id = s.paramId
            });
          }
          indent.asks = _data.expressions
          this.indentData = indent
        })
      },
      submitIndent() {
        if (!this.indentData.name) {
          this.$Modal.info({
            title:'提示',
            content:'意图名称不能为空'
          })
          return
        }
        if (!this.indentData.asks[0].expression) {
          this.$Modal.info({
            title:'提示',
            content:'用户话术不能为空'
          })
          return
        }
        let that = this
        if (this.indentData.id) {
          let param = {
            purposeId:this.indentId,
            rwId:this.flowId,
            name:this.indentData.name,
            expressions: JSON.stringify(this.indentData.asks),
            deleteExpressions: JSON.stringify(this.deleteExpressions),
            slots:JSON.stringify(this.indentData.slots),
            deleteSlots: JSON.stringify(this.deleteSlots),
            menuId:'a_2-8',
            journalType:'AI机器人管理=>流程绘制=>编辑意图'
          }
          this.$http.post('/AI/FlowDetail/updateIndent',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              })
            }else {
              that.$Message.success("编辑意图成功！")
              that.showDialog = false
            }
          })
          //修改
        } else {
          //添加
          let param = {
            name:this.indentData.name,
            rwId:this.flowId,
            expressions:JSON.stringify(this.indentData.asks),
            slots:JSON.stringify(this.indentData.slots),
            menuId:'a_2-8',
            journalType: 'AI机器人管理=>流程绘制=>新建意图'
          }
          this.$http.post('/AI/FlowDetail/addIndent',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              that.$Modal.info({
                title: '提示',
                content: res.data.msg
              });
            } else {
              that.$Message.success("新增意图成功！")
              that.showDialog = false
            }
          })
        }
      },
      handleDeleteAsk(ask) {
        let index = this.indentData.asks.indexOf(ask)
        if (index > -1) {
          this.deleteExpressions.push(ask.id+'')
          this.indentData.asks.splice(index,1)
        }
      },
      handleAddAsk() {
        this.indentData.asks.push({expression:'',id:'',key:Date.now()})
      },
      handleDelete(index, row) {
        this.indentData.slots.splice(index,1)
        if (row.id !== '') {
          this.deleteSlots.push(row.id+'')
        }
      },
      handleAdd() {
        this.indentData.slots.push({paramName:'',tempName:'',id:'',nounId:'',key:Date.now()})
      },
      querySearch(queryString, cb) {
        let restaurants = this.sysSlot
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        cb(results)
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      handleSelect(item) {
        if (this.sysSlot) {
          this.sysSlot.forEach(s => {
            if (s.value === item.tempName) {
              this.indentData.slots.forEach(slot => {
                if (item.id) {
                  if (item.id === slot.id) {
                    slot.nounId = s.id
                  }
                } else {
                  if (item.key === slot.key) {
                    slot.nounId = s.id
                  }
                }
              });
            }
          });
        }
      }
    },
    watch:{
      isEdit:{
        deep:true,
        handler(val) {
          if (val) {
            this.title = '编辑意图'
          } else {
            this.title = '新增意图'
          }
        }
      },
      show:{
        deep:true,
        immediate:true,
        handler(val) {
          this.showDialog = val
          if (val) {
            this.initSlot(this.flowId)
            if (this.indentId) {
              this.loadData(this.indentId);
            } else {
              this.indentData = {id:'',name:'',asks:[{expression:''}],slots:[]}
            }
          }
        }
      }
    }
  }
</script>

<style scoped lang="css">
  .prefix{
    width: 20%;
    text-align: right;
    float: left;
    line-height: 32px;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .suffix{
    width: 75%;
    float: left;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .addClass{
    width: 100%;
    float: left;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .offsetX{
    margin-left: 20%;
  }
  .addOffsetX{
    margin-left: 20%;
  }
  a{
    color: #3da8f1;
  }
  .tip-img {
    max-width: 13px;
    max-height: 13px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flow/components/IndentDialog.vue